import mafamvisual from "./mafamvisual.png";
import videocrc from "./videocrc.png";
import videocrc1 from "./videocrc1.png";
import film from "./fiml.png";
import netflix from "./netflix.png";
import srmg from "./srmg.png";
import unisco from "./unisco.png";
import Rectangle39 from "./Rectangle39.png";
import Rectangle40 from "./Rectangle40.png";
import Rectangle41 from "./Rectangle41.png";
import Rectangle42 from "./Rectangle42.png";
import Rectangle43 from "./Rectangle43.png";
import Rectangle1 from "./Rectangle1.png";
import Rectangle2 from "./Rectangle2.png";
import instructiobg from "./instructiobg.png";
import neom from "./neom.png";
import majid from "./majid.png";
import jeddahs from "./jeddahs.png";
import jameel from "./jameel.png";
import ignity from "./ignity.png";
import growCreative from "./growCreative.png";
import studio from "./studio.png";
import redsea from "./redsea.png";
import Frame259 from "./Frame259.png";
import Frame63 from "./Frame63.png";
import pricing from "./pricing1.png";
import Rectangle13 from "./Rectangle13.png";
import Rectangl13 from "./Rectangl13.png";
import Rectangl14 from "./Rectangl14.png";
import Rectangl15 from "./Rectangl15.png";
import Rectangle83 from "./Rectangle83.png";
import Rectangle84 from "./Rectangle84.png";
import Rectangle85 from "./Rectangle85.png";
import Rectangle87 from "./Rectangle87.png";
import course1 from "./course1.png";
import course2 from "./course2.png";
import course3 from "./course3.png";
import course4 from "./course4.png";
import course5 from "./course5.png";
import course6 from "./course6.png";
import course7 from "./course7.png";
import course8 from "./course8.png";
import course9 from "./course9.png";
import filmaker from "./filmaker.png";
import rectangle21 from "./Rectangle21.png";
import rectangle22 from "./Rectangle22.png";
import Google from "./Google.png";
import Email from "./Email.png";
import LinkedIn from "./LinkedIn.png";
import recapture from "./recapture.png";
import variousCourse1 from "./variousCourse1.png";
import variousCourse2 from "./variousCourse2.png";
import variousCourse3 from "./variousCourse3.png";
import variousCourse4 from "./variousCourse4.png";
import variousCourse5 from "./variousCourse5.png";
import variousCourse6 from "./variousCourse6.png";
import variousCourse7 from "./variousCourse7.png";
import variousCourse8 from "./variousCourse8.png";
import Visa from "./Visa.png";
import filter from "./filter.png";
import MasterCard from "./MasterCard.png";
import Mada from "./Mada.png";
import Checkoutbg from "./Checkoutbg.png";
import Checkout from "./Checkout.png";

import blogpage2 from "./blogpage2.png";
import ebook1 from "./ebook1.png";
import ebook2 from "./ebook2.png";
import ebook3 from "./ebook3.png";
import ebook4 from "./ebook4.png";
import ebook5 from "./ebook5.png";

import Blog1 from "./Blog1.png";
import Blog2 from "./Blog2.png";
import Blog3 from "./Blog3.png";
import mainBlog from "./mainBlog.png";
import Insights1 from "./Insights1.png";
import Insights2 from "./Insights2.png";
import Insights3 from "./Insighs3.png";
import Popular1 from "./Popular1.png";
import Popular2 from "./Popular2.png";
import Popular3 from "./Popular3.png";
import Popular4 from "./Popular4.png";
import Ellipse1 from "./Ellipse1.png";
import Ellipse2 from "./Ellipse2.png";
import Ellipse3 from "./Ellipse3.png";
import Ellipse4 from "./Ellipse4.png";
import Ellipse5 from "./Ellipse5.png";
import Ellipse6 from "./Ellipse6.png";
import Groups from "./Group.png";
import caraImg from "./Carouselimg.png";
import EbookCard1 from "./E-bookletsCard-1.png";
import EbookCard2 from "./E-bookletsCard-2.png";
import EbookCard3 from "./E-bookletsCard-3.png";
import Reactangle48 from "./Rectangle 48.png";
import Reactangle49 from "./Rectangle 49.png";
import Reactangle50 from "./Rectangle 50.png";
import Reactangle51 from "./Rectangle 51.png";
import logo14 from "./logo14.png";
import logo15 from "./logo15.png";
import logo16 from "./logo16.png";
import logo19 from "./logo19.png";
import carouselcard1 from "./CarouselCard1.png";
import carouselcard2 from "./CarouselCard2.png";
import carouselcard3 from "./CarouselCard3.png";
import quotes from "./quotes icon.png";
import quotesArabic from "./quotes iconar.png";
import LearnMaflamImage from "./LearnMaflamImage.png";

import maflamScreen from "./Maflam-Screen.png";
import Subscribee from "./Subscribee.png";
import PricingHeroBackground from "./PricingHeroBackground.png";
import PricingCard1Background from "./pricingCard1background.png";
import youtubeImage from "./youtubeImage.png";
import backgrounds from "./backgronds.png";
import aboutHero from "./aboutHero.png";
import FrameDiv1 from "./FrameDiv1.png";
import FrameDiv2 from "./FrameDiv2.png";
import FrameDiv3 from "./FrameDiv3.png";
import FrameDiv4 from "./FrameDiv4.png";
import FrameDiv5 from "./FrameDiv5.png";
import FrameDiv6 from "./FrameDiv6.png";
import FrameDiv7 from "./FrameDiv7.png";
import logo1 from "./logo1.png";
import Footerlogo1 from "./footerlogo.png";
import Magnifine from "./magnifine.png";
import Globe from "./globe.png";
import ContactInfoLogo from "./ContactInfoLogo.png";
import joinOurTeam from "./joinOurTeam.png";
import TraningProgramLogo from "./TraningProgramLogo.png";
import  FullCourse from "./FullCourse.png"
import  ScriptingWriting from "./ScriptingWriting.png"
import  Production from "./Production.png"
import  Directing from "./Directing.png"
import  Cinematography from "./Cinematography.png"
import  RecordingCourse from "./RecordingCourse.png"
import  ActingCourse from "./ActingCourse.png"
import  EditingCourse from "./EditingCourse.png"
import  MaflamBlog from "./MaflamBlog.png"
import  SocialMedia from "./SocialMedia.png"
import  ebook from "./ebook.png"
import  MaflamBlog1 from "./MaflamBlog.png"
import  Facebooklogin from "./Facebooklogin.png"
import  applelogin from "./applelogin.png"
import  eyeicon from "./eyeicon.png"
import  successtickmark from "./successtickmark.png"
import  Arrow from "./Arrow.png"
import  colorArrow from "./rightNavArrow.png"
import  leftArrow from "./leftNavArrow.png"
import  profilecourse from "./profilecourse.png"
import  profilecoursefirst from "./profilecoursefirst.png"

import instagram from "./instaram.png"
import youtube from "./youtube.png"
import tiktok from "./tiktok.png"
import socialimage from "./socialimage.png"
import channel1 from "./channel1.png"
import channel2 from "./channel2.png"

import youtubeicon from "./youtubeicon.png"
import education1 from "./education1.png"
import education2 from "./education2.png"

import education3 from "./education3.png"
import eventpic from "./eventpic.png"
import instagramlogo from "./instagraplogo.png"
import posdcost from "./podcost.png"
import Maflammac from "./Maflammac.png"
import heartlogo from "./heartlogo.png"
import downarrow from "./downarrow.png"
import showcase from "./showcase.png"
import onebooklet from "./onebooklet.png"
import twobooklet from "./twobooklet.png"
import threebooklet from "./threebooklet.png"
import filmvideoimg from "./filmvideoimg.png"
import subscribefundamentalpackage from "./subscribefundamentalpackage.png"
import  ContactCardI3 from "./ContactCardI3.png"
import  ContactCardI2 from "./ContactCardI2.png"
import  ContactCardI1 from "./ContactCardI1.png"
import detailsbg from "./detailsbg.png"
import CarouselLeftArrow from "./CarouselLeftArrow.png"
import MWFormGrad from "./MWFormGrad.png"
import ContactFormUploadPng from "./ContactFormUploadPng.png"
import Socilamediaallpage from "./Socilamediaallpage.png"



export const assests = {
  subscribefundamentalpackage,
  Socilamediaallpage ,
  MWFormGrad,
  ContactFormUploadPng,
  CarouselLeftArrow,
  detailsbg,
  ContactCardI1,
  ContactCardI2,
  ContactCardI3,
  filmvideoimg,
  threebooklet,
  twobooklet,
  onebooklet,
  showcase,
  downarrow,
  instagram ,
  heartlogo,
  instagramlogo,
  youtube,
  tiktok,
  channel1 ,
  channel2 ,
  youtubeicon,
  socialimage,
  education1,
  education2,
  education3,
  eventpic,
  posdcost ,
  Maflammac,
  profilecoursefirst,
  profilecourse,
  Arrow,
  successtickmark,
  eyeicon,

  applelogin,
  Facebooklogin,
  Magnifine,
  Globe,
  youtubeImage,
  PricingHeroBackground,
  PricingCard1Background,
  caraImg,
  Popular1,
  Popular2,
  filter,
  logo1,
  Popular3,
  Popular4,
  Insights1,
  Insights2,
  Insights3,
  Blog1,
  Blog2,
  Blog3,
  mainBlog,
  recapture,
  LinkedIn,
  Email,
  Google,
  Rectangle1,
  Rectangle2,
  Rectangle39,
  Rectangle40,
  Rectangle41,
  Rectangle42,
  Rectangle43,
  instructiobg,
  colorArrow,
  leftArrow,
  film,
  netflix,
  srmg,
  unisco,
  ignity,
  jameel,
  jeddahs,
  majid,
  neom,
  growCreative,
  redsea,
  studio,
  Frame259,
  Frame63,
  pricing,
  Rectangle13,
  LearnMaflamImage,
  Rectangl13,
  Rectangl14,
  Rectangl15,
  Rectangle83,
  Rectangle84,
  Rectangle85,
  Rectangle87,
  mafamvisual,
  filmaker,
  course1,
  course2,
  course3,
  course4,
  course5,
  course6,
  course7,
  course8,
  course9,
  rectangle21,
  rectangle22,
  blogpage2,
  variousCourse8,
  variousCourse7,
  variousCourse6,
  variousCourse5,
  variousCourse4,
  variousCourse3,
  variousCourse2,
  variousCourse1,
  Visa,
  MasterCard,
  Mada,
  Checkoutbg,
  Checkout,
  ebook1,
  ebook2,
  ebook3,
  ebook4,
  ebook5,
  EbookCard1,
  EbookCard2,
  EbookCard3,
  Reactangle48,
  Reactangle49,
  Reactangle50,
  Reactangle51,
  logo14,
  logo15,
  logo16,
  logo19,
  carouselcard1,
  carouselcard2,
  carouselcard3,
  quotes,
  quotesArabic,

  videocrc,
  videocrc1,
  maflamScreen,
  Subscribee,
  Footerlogo1,
  ContactInfoLogo,
  joinOurTeam,
  TraningProgramLogo,
  ActingCourse,
  Cinematography,
  Directing,
  EditingCourse,
  FullCourse,
  Production,
  RecordingCourse,
  ScriptingWriting,
  MaflamBlog,
  ebook,
  SocialMedia,
  MaflamBlog1,
  
};



// export const  youtubeChannel =[
//   {title : "A program presented by cinematographer Osama Rabihan, explaining in detail various filming equipment and how to use it to fit your film.",
// episode :"For more episodes",
// imageurl : channel1 ,
// videoId: "https://www.youtube.com/watch?v=uzU-S7_XMXc",
// imagelogo :logo14  ,
// icon : youtubeicon
//    },
//    {title : "A program presented by cinematographer Osama Rabihan, explaining in detail various filming equipment and how to use it to fit your film.",
//     episode :"For more episodes",
//     imageurl :channel2  ,
//     videoId: "https://www.youtube.com/watch?v=uzU-S7_XMXc",
    // imagelogo :logo19 ,
    // icon : youtubeicon
//        },
// ] 

export   const BundleCourseCard = [
  {
    id: 1,
    title: "Fundamentals of Film Directing",
    description:
      "This course will focus on explaining the role of the director and how he implements his vision in the film. It will also cover how to prepare for the film, direct the actors, and deal with the work team, in addition to all the directing rules.",
        
    imageUrl: variousCourse1,
  },
  {
    id: 2,
    title: "Fundamentals of Film Production",
    description:
      "In this course, you will learn all the production details, starting from conducting a feasibility study for the film and determining the budget, contracting the work team, managing the filming location, and even entering the film into the editing room.",
   
    imageUrl: variousCourse2,
  },
  {
    id: 3,
    title: "Fundamentals of Screenwriting",
    description:
      "In this course, you will learn how to write a cinematic treatment for your story, build the scenario with all its elements, delve deeply into how to create exciting and deep characters, and understand the subject and message while writing the story.",
    
    imageUrl: Checkout,
  },
  {
    id: 4,
    title: "Fundamentals of Acting",
    description:
      "This course will focus on explaining the director's role and how to execute their vision in the film. It will also cover how to prepare for the film, direct actors, collaborate with the crew, and address all the directing principles.",
   
    imageUrl: variousCourse3,
  },
  {
    id: 5,
    title: "Fundamentals of Sound Recording",
    description:
      "In this course, you will learn all the production details, starting with conducting a feasibility study for the film and setting the budget, hiring the crew, managing the filming location, and all the way to the film's entry into the editing room.",
  
    imageUrl: variousCourse4,
  },
  {
    id: 6,
    title: "Fundamentals of Cinematography",
    description:
      "In this course, you will learn all the production details, starting with conducting a feasibility study for the film and setting the budget, hiring the crew, managing the filming location, and all the way to the film's entry into the editing room.",
    
    imageUrl: variousCourse5,
  },
  
];

export const BundleExclusiveCourseCard = [
 
  {
    id: 1,
    title: "Fundamentals of Editing in Vegas Pro",
    description:"You will learn the main features of Vegas Pro in this course, including how to create a project file, split files, adjust the right segments, add effects and graphics, work with the audio and video tracks, and understand the general rules of editing",
   
    imageUrl: variousCourse2,
  },
  {
    id: 2,
    title: "Fundamentals of Editing in Davinci Resolve",
    description:"In this course, you will learn how to use many functions of DaVinci Resolve, such as cutting, editing, merging, and coloring tracks, managing the media pool, and adding effects and graphics. You will also learn how to set up a project, adjust the audio track, and have full control over all the program's options.",
    
    imageUrl: Checkout,
  },
  {
    id: 3,
    title: "Fundamentals of Editing in Adobe Premiere Pro",
    description:"In this course, you will master the use of Premiere, learning how to start a project and utilize all available tools and effects. You will also cover exporting files in different formats, adjusting color and sound sharpness, and other details of professional editing",
   
    imageUrl: variousCourse3,
  },
  {
    id: 4,
    title: "Working in Film Industry",
    description:"In this course, you will learn all the details related to a career in filmmaking that can make you a professional and responsible filmmaker. You will learn how to organize your day, what to bring with you to the set, how to set your rates, how to handle criticism, how to work with the crew, and how to land your first projects.",
  
    imageUrl: variousCourse4,
  },
  {
    id: 5,
    title: "An Introduction to Filmmaking",
    description:"In this course, you will learn the best ways to start planning and preparing for a film, the stages of filmmaking and their divisions based on the film industry. You will also get to know the Maflam platform and how to access everything easily",
    
    imageUrl: variousCourse5,
  },
  
];

export const youtubeChannel = [
  {
    title: "برنامج يقدمه مدير التصوير أسامة ربيحان، ليشرح بالتفصيل معدات التصوير المختلفة، وكيفية استخدامها بشكل يتناسب مع فيلمك.",
    episode: "المزيد من الحلقات",
    imageurl: "path/to/channel1-image.jpg", // Replace with actual image path
    videoId: "uzU-S7_XMXc",
    imagelogo :logo14  ,
    icon : youtubeicon
  },
  {
    title: "برنامج يستضيف صنّاع أفلام شباب، ليقدموا لنا نظرة تفصيلية عن دورهم في عملية صناعة الفيلم، والتحديات التي مروا بها.",
    episode: "المزيد من الحلقات",
    imageurl: "path/to/channel2-image.jpg", // Replace with actual image path
    videoId: "-KKH3t_h9pA",
    imagelogo :logo19 ,
    icon : youtubeicon
  }
];



export const EducationPost =[
  {title: "Educational content that reveals secrets of the filmmaking profession and explains why it is so important.",
episode :"More",
imageurl : education1,

   },
   {title : "Motivational quotes from world-renowned filmmakers based on their experiences in the field.",
    episode :"More",
    imageurl :education2,
   
       },
       {title : "Fun posts to engage with filmmakers.",
        episode :"More",
        imageurl :education3 
       
           },
]

export const instructors = [
  { name: "Ayman Khoja", image: Rectangle2 },
  { name: "Aseel Radwan", image: Rectangle39 },
  { name: "Afnan Linjawi", image: Rectangle40 },
  { name: "Khalid AlSudaairy", image: Rectangle41 },
  { name: "Odai Abed", image: Rectangle42 },
  { name: "Khalid Yaslam", image: Rectangle43 },
];
export const blogPosts = [
  {
    id: 1,
    category: "Category",
    title: "What does a film producer do?",
    linkText: "→ Continue reading ",
    image: Blog1,
  },
  {
    id: 2,
    category: "Category",
    title: "How do you showcase your unique writing style?",
    linkText: "→ Continue reading ",
    image: Blog2,
  },
  {
    id: 3,
    category: "Category",
    title: "The Significance of Storytelling",
    linkText: "→ Continue reading",
    image: Blog3,
  },
];

export const BlogHeaderData = [
  {
    title: "مع فريق العمل داخل الفيلم؟",
    title2: "كيف يتعامل المخرج المحترف",
    subTitle: "الصحفية والوصول إلى التنزيلات الإعلامية",
    subTitle2: "احصل على تحديثات الشركة والتغطية",
    name: "Afnan Linjawi",
    date: "october 15,2023",
  },
];

export const CoursesData = [
  { name: "Scriptwriting", backgroundImage: `url(${FrameDiv7})` },
  { name: "Production", backgroundImage: `url(${FrameDiv6})` },
  { name: "Cinematography", backgroundImage: `url(${FrameDiv3})` },
  { name: "Directing", backgroundImage: `url(${FrameDiv4})` },
  { name: "Sound Recording", backgroundImage: `url(${FrameDiv5})` },
  { name: "Acting", backgroundImage: `url(${FrameDiv2})` },
  { name: "Editing", backgroundImage: `url(${FrameDiv1})` },
];

export const questionsData = [
  {
    question: "Scriptwriting Introduction",
    answers: [
      "The Importance of Filmmaking ",
      "Stages of Film Production ",
      "Film Crew Departments ",
      "Understanding the Hierarchical",
      "Structure of the Production Team  ",
      "About Maflam Platform ",
    ],
    timeStamp: [
          "3:59",
          "2:49",
          "3:20",
          "2:39",
          "1:39",

    ]
  },
  
  {
    question: "From Idea to Story",
    answers: [
      "It helps learners grasp essential skills to manage a film production efficiently.",
      "Understanding the basics ensures better decision-making during filming.",
    ],
  },
  {
    question: "From Story to Processing",
    answers: [
      "This knowledge can be applied by practicing with real-life film projects.",
      "Directors can use these skills to enhance their communication with actors.",
    ],
  },
  {
    question: "From Processing to Script",
    answers: [
      "Script Structure: Chapters and Scene Breakdowns (Part One) - 12:30 ",
      " Script Structure: Chapters and Scene Breakdowns (Part Two) - 13:11",
      "Workshop: Writing Scene Breakdowns - 3:36",
      "Script Structure: Types of Scenes - 7:06",
      "Script Structure: Moments - 6:27 ",
      "Elements of Scene Building - 11:39 ",
      "Technical Rules for Writing Scenes - 13:57 ",
      "Types of Dialogue - 12:00 ",
      "Foundations of Writing Dialogue - 11:08",
      "Screenwriting Software - 3:16 ",
      "Technique for Writing Descriptions and Annotations - 11:31 ",
      "Dialogue Writing Technique - 11:24",
      "Workshop: Writing Dialogue - 5:34",
      "Technique for Writing Transitions - 6:40 ",
      "Scene Outline - 11:47 ",
      " Workshop: Scene Outline - 4:00",
      "Editing for Production - 6:49 ",
    ],
  },
  {
    question: "Conclusion",
    answers: [
      "This knowledge can be applied by practicing with real-life film projects.",
      "Directors can use these skills to enhance their communication with actors.",
    ],
  },
];




export const CourseContentData = [
  {
    question: "Scriptwriting Introduction",
    answers: [
      "The Importance of Filmmaking ",
      "Stages of Film Production ",
      "Film Crew Departments ",
      "Understanding the Hierarchical",
      "Structure of the Production Team  ",
      "About Maflam Platform ",
    ],
    timeStamp: [
          "3:59",
          "2:49",
          "3:20",
          "2:39",
          "1:39",

    ]
  },
  {
    question: "Scriptwriting Introduction",
    answers: [
      "The Importance of Filmmaking ",
      "Stages of Film Production ",
      "Film Crew Departments ",
      "Understanding the Hierarchical",
      "Structure of the Production Team  ",
      "About Maflam Platform ",
    ],
    timeStamp: [
          "3:59",
          "2:49",
          "3:20",
          "2:39",
          "1:39",

    ]
  },
  {
    question: "Scriptwriting Introduction",
    answers: [
      "The Importance of Filmmaking ",
      "Stages of Film Production ",
      "Film Crew Departments ",
      "Understanding the Hierarchical",
      "Structure of the Production Team  ",
      "About Maflam Platform ",
    ],
    timeStamp: [
          "3:59",
          "2:49",
          "3:20",
          "2:39",
          "1:39",

    ]
  },
  {
    question: "Scriptwriting Introduction",
    answers: [
      "The Importance of Filmmaking ",
      "Stages of Film Production ",
      "Film Crew Departments ",
      "Understanding the Hierarchical",
      "Structure of the Production Team  ",
      "About Maflam Platform ",
    ],
    timeStamp: [
          "3:59",
          "2:49",
          "3:20",
          "2:39",
          "1:39",

    ]
  },
  {
    question: "Scriptwriting Introduction",
    answers: [
      "The Importance of Filmmaking ",
      "Stages of Film Production ",
      "Film Crew Departments ",
      "Understanding the Hierarchical",
      "Structure of the Production Team  ",
      "About Maflam Platform ",
    ],
    timeStamp: [
          "3:59",
          "2:49",
          "3:20",
          "2:39",
          "1:39",

    ]
  },
  
  
];



//import latest insights
export const insights = [
  {
    id: 1,
    title: "Our mission is to deliver top-quality educational content.",
    imageUrl: Insights1,
    category: "GL18",
  },
  {
    id: 2,
    title: "Our mission is to deliver top-quality educational content.",
    imageUrl: Insights2,
    category: "GL18",
  },
  {
    id: 3,
    title: "Our mission is to deliver top-quality educational content.",
    imageUrl: Insights3,
    category: "GL18",
  },
];
export const resources = [
  {
    id: 1,
    description: "We partner with over 300 leading universities and companies.",
    imageUrl: Popular1, // Replace with actual image paths
    category: "Category",
  },
  {
    id: 2,
    description: "We partner with over 300 leading universities and companies.",
    imageUrl: Popular2, // Replace with actual image paths
    category: "Category",
  },
  {
    id: 3,
    description: "We partner with over 300 leading universities and companies.",
    imageUrl: Popular3, // Replace with actual image paths
    category: "Category",
  },
  {
    id: 4,
    description: "We partner with over 300 leading universities and companies.",
    imageUrl: Popular4, // Replace with actual image paths
    category: "Category",
  },
];

export const featuresData = [
  {
    title: "A Community of Aspiring Filmmakers",

  },
  {
    title: "A Passion for Empowering Cinematic Talents",

  },
  {
    title: "A Comprehensive Educational Experience in Arabic",

  },
];

export const offersData = [
  {
    title: "Training Programs",
    image: Frame63,
  },
  {
    title: "Networking Opportunities",
    image: Rectangle13,
  },
  {
    title: "Mentorship and Training",
    image: Rectangl13,
  },
  {
    title: "Courses and Workshops",
    image: Rectangl14,
  },
  {
    title: "Artistic Consultations",
    image: Rectangl15,
  },
];
// SuccessPartnersData.js
export const successPartnerss = [
  { name: "Saudi Film Confex", logo: film },
  { name: "SRMG", logo: srmg },
  { name: "GrowCreative", logo: growCreative },
  { name: "UNESCO", logo: unisco },
  { name: "Red Sea", logo: redsea },
  { name: "Ignite", logo: ignity },
  { name: "Art Jameel", logo: jameel },
  { name: "Jeddah X", logo: jeddahs },
  { name: "Netflix", logo: netflix },
  { name: "NEOM", logo: neom },
  { name: "Majid", logo: majid },
  { name: "Telfaz11 Studios", logo: studio },
];

export const MaflamCards = [
  {
    title: "Osama Rubihan",
    image: Rectangle83,
  },
  {
    title: "Zakaria Bashir",
    image: Rectangle84,
  },
  {
    title: "Shahad Almudawi",
    image: Rectangle85,
  },
];

export const contentData = [
  {
    title: "Our Vision",
    description:
      "Our vision is to become the leading solution that meets the needs of ambitious Arab students striving for excellence in the art of filmmaking.",
  },
  {
    title: "Our Mission",
    description:
      "Our mission is to nurture young talent, foster creativity, and provide filmmakers with the tools and expertise they need to succeed in the world of cinema.",
  },
];

export const courses = [
  { title: "Fundamentals of Cinematography", img: course7 },
  { title: "Fundamentals of Film Production", img: course8 },
  { title: "Fundamentals of Scriptwriting", img: course9 },
  { title: "Fundamentals of Acting", img: course1 },
  { title: "Fundamentals of Sound Recording", img: course4 },
  { title: "Fundamentals of Film Directing", img: course3 },
  { title: "Introduction to DaVinci Resolve", img: course6 },
  { title: "Introduction to Vegas Pro", img: course5 },
  { title: "Introduction to Premiere Pro", img: course2 },
];

export const faqData = [
  {
    question: "When doese my course subscription end?",
    answer:
      "At maflam,we ensure lifetime access to our film-making content.Once you make a purchase, you gain permanent access to our exclusive educational materials,available anytime and from anywhere.",
  },
  {
    question: "Why should i choose a full course to learn film-making?",
    answer:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, cum nam eius quod deserunt quidem libero quo dignissimos esse nobis alias aliquam eaque sit assumenda distinctio excepturi iure minima nesciunt.",
  },
  {
    question: "How do you select instructors on Maflam's platform?",
    answer:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, cum nam eius quod deserunt quidem libero quo dignissimos esse nobis alias aliquam eaque sit assumenda distinctio excepturi iure minima nesciunt.",
  },
  {
    question: "When doese my course subscription end?",
    answer:
      "At maflam,we ensure lifetime access to our film-making content.Once you make a purchase, you gain permanent access to our exclusive educational materials,available anytime and from anywhere.",
  },
  {
    question: "Is there practical content on the مَفلَم platform?",
    answer:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, cum nam eius quod deserunt quidem libero quo dignissimos esse nobis alias aliquam eaque sit assumenda distinctio excepturi iure minima nesciunt.",
  },
  {
    question: "How do you select instructors on Maflam's platform?",
    answer:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, cum nam eius quod deserunt quidem libero quo dignissimos esse nobis alias aliquam eaque sit assumenda distinctio excepturi iure minima nesciunt.",
  },
  {
    question:
      "Will I receive a compietion certificate after finishing a course?",
    answer:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, cum nam eius quod deserunt quidem libero quo dignissimos esse nobis alias aliquam eaque sit assumenda distinctio excepturi iure minima nesciunt.",
  },
];

export const VisionData = [
  {
    title: "Our Vision",
    text: "Our vision is to become the leading solution that meets the needs of ambitious Arab students striving for excellence in the art of filmmaking.",
  },
  {
    title: "Our Mission",
    text: "Our mission is to nurture young talent, foster creativity, and provide filmmakers with the tools and expertise they need to succeed in the world of cinema.",
  },
];

export const VariousCard = [
  {
    id: 1,
    instructor: "Odai Abeed",
    title: "Fundamentals of Film Directing",
    description:
      "This course will focus on explaining the role of the director and how he implements his vision in the film. It will also cover how to prepare for the film, direct the actors, and deal with the work team, in addition to all the directing rules.",
    para: "SAR ",
    price: "750",
    image: Ellipse1,
    button: "Buy Now",

    duration: "5 hours of viewing",
    icon: Groups,
    imageUrl: variousCourse1,
  },
  {
    id: 2,
    instructor: "Ayman Khoja",
    title: "Fundamentals of Film Production",
    description:
      "In this course, you will learn all the production details, starting from conducting a feasibility study for the film and determining the budget, contracting the work team, managing the filming location, and even entering the film into the editing room.",
    price: "750",
    para: "SAR ",
    image: Ellipse2,
    duration: "5 hours of viewing",
    icon: Groups,
    imageUrl: variousCourse2,
  },
  {
    id: 3,
    instructor: "Ayman Khoja",
    title: "Fundamentals of Screenwriting",
    description:
      "In this course, you will learn how to write a cinematic treatment for your story, build the scenario with all its elements, delve deeply into how to create exciting and deep characters, and understand the subject and message while writing the story.",
    price: "750",
    para: "SAR ",
    image: Ellipse3,
    duration: "5 hours of viewing",
    icon: Groups,
    imageUrl: Checkout,
  },
  {
    id: 4,
    instructor: "Ayman Khoja",
    title: "Fundamentals of Acting",
    description:
      "This course will focus on explaining the director's role and how to execute their vision in the film. It will also cover how to prepare for the film, direct actors, collaborate with the crew, and address all the directing principles.",
    price: "750",
    para: "SAR ",
    image: Ellipse4,
    duration: "5 hours of viewing",
    icon: Groups,
    imageUrl: variousCourse3,
  },
  {
    id: 5,
    instructor: "Ayman Khoja",
    title: "Fundamentals of Sound Recording",
    description:
      "In this course, you will learn all the production details, starting with conducting a feasibility study for the film and setting the budget, hiring the crew, managing the filming location, and all the way to the film's entry into the editing room.",
    price: "750",
    para: "SAR ",
    image: Ellipse5,
    duration: "5 hours of viewing",
    icon: Groups,
    imageUrl: variousCourse4,
  },
  {
    id: 6,
    instructor: "Ayman Khoja",
    title: "Fundamentals of Cinematography",
    description:
      "In this course, you will learn all the production details, starting with conducting a feasibility study for the film and setting the budget, hiring the crew, managing the filming location, and all the way to the film's entry into the editing room.",
    price: "750",
    para: "SAR ",
    image: Ellipse6,
    duration: "5 hours of viewing",
    icon: Groups,
    imageUrl: variousCourse5,
  },
  // {
  //   id: 7,
  //   instructor: "Ayman Khoja",
  //   title: "Introduction to Vegas Pro",
  //   description:
  //     "In this course, we will explore the challenges filmmakers face, how to manage and overcome them. We will also discuss how they create a balance between their work and personal life, set their pricing, and engage with the community.",
  //   price: "750",
  //   para: "SAR ",

  //   duration: "5 hours of viewing",
  //   icon: Groups,
  //   imageUrl: variousCourse6,
  // },
  // {
  //   id: 8,
  //   instructor: "Ayman Khoja",
  //   title: "Introduction to DaVinci Resolve",
  //   description:
  //     "In this course, we will explore the challenges filmmakers face and how to address and overcome them. We will also discuss how they balance their work and personal life, set their rates, and interact with the community.",
  //   price: "750",
  //   para: "SAR ",
  //   duration: "5 hours of viewing",
  //   icon: Groups,
  //   imageUrl: variousCourse7,
  // },
  // {
  //   id: 9,
  //   instructor: "Ayman Khoja",
  //   title: "Introduction to Premiere Pro",
  //   description:
  //     "In this course, you will master the use of Premiere, how to start a project and use all the available tools and effects, in addition to extracting files in different formats, adjusting color and sound intensity, and other details of professional editing.",
  //   price: "750",
  //   para: "SAR ",
  //   duration: "5 hours of viewing",
  //   icon: Groups,
  //   imageUrl: variousCourse8,
  // },
];

export const articles =
 [
    {
      "title": "How does a professional Director Manage the Crew on Set?",
      "description": "Educational, Entertaining, Research-Based, Critical",
      "category": "Educational",
      "imageUrl": "image1_url",
      "readMoreLink": "#"
    },
    {
      "title": "What does a film producer do?",
      "category": "Category",
      "imageUrl": "image2_url",
      "readMoreLink": "#"
    },
    {
      "title": "How do you showcase your unique writing style?",
      "category": "Category",
      "imageUrl": "image3_url",
      "readMoreLink": "#"
    },
    {
      "title": "The Significance of Storytelling",
      "category": "Category",
      "imageUrl": "image4_url",
      "readMoreLink": "#"
    }
  ]



// export const cardDetails = {
//   title: "Subscribe To The Full Filmmaking Fundamentals Package",
//   title2: "Payment by credit or debit card",
//   cardImg: Visa,
//   cardImg1: MasterCard,
//   cardImg2: Mada,
//   priceHead: "2200 SAR",
//   price: "Pay SAR 2200",
//   imageSrc: Checkout,
//   para: "Contact Us for Checkout",
//   termcondition:
//     "Your subscription will automatically renew each year. After the first year, you will be charged SAR 750 for each renewal until you cancel your subscription. You can cancel at any time on your account's subscription page or by submitting a support request. If you cancel, previous fees will not be refunded, but you can continue to use the service until the end of the period you have paid for.",
//   termcondition1: "By clicking the 'Pay' button above, you agree to the ",
//   termcondition2: " and acknowledge that you have read our .",
// };

export const cardDetails = {
  en: {
    title: "Subscribe To The Full Filmmaking Fundamentals Package",
    title2: "Payment by credit or debit card",
    cardImg: Visa,
    cardImg1: MasterCard,
    cardImg2: Mada,
    priceHead: "2200 SAR",
    price: "Pay SAR 2200",
    imageSrc: Checkout,
    para: "Contact Us for Checkout",
    termcondition:
      "Your subscription will automatically renew each year. After the first year, you will be charged SAR 750 for each renewal until you cancel your subscription. You can cancel at any time on your account's subscription page or by submitting a support request. If you cancel, previous fees will not be refunded, but you can continue to use the service until the end of the period you have paid for.",
    termcondition1: "By clicking the 'Pay' button above, you agree to the ",
    termcondition2: " and acknowledge that you have read our .",
  },
  ar: {
    title: "اشترك في حزمة أساسيات صناعة الأفلام الكاملة",
    title2: "الدفع بواسطة بطاقة الائتمان أو بطاقة الخصم",
    cardImg: Visa,
    cardImg1: MasterCard,
    cardImg2: Mada,
    priceHead: "SAR 2200",
    price: "إدفع SAR 2200",
    imageSrc: Checkout,
    para: "تواصل معنا لإتمام الدفع",
    termcondition:
      "سيتم تجديد اشتراكك تلقائيًا كل عام. بعد السنة الأولى، سيتم تحصيل مبلغ 750 ريال سعودي لكل تجديد حتى تقوم بإلغاء الاشتراك. يمكنك الإلغاء في أي وقت من صفحة اشتراك حسابك أو عن طريق إرسال طلب دعم. إذا قمت بالإلغاء، فلن يتم رد الرسوم السابقة، ولكن يمكنك الاستمرار في استخدام الخدمة حتى نهاية الفترة التي دفعت ثمنها.",
    termcondition1: "بالنقر على زر 'إدفع' أعلاه، فإنك توافق على ",
    termcondition2: "وتقر بأنك قد قرأت .",
  },
};

export const ebooks = [
  {
    id: 1,
    title: "How to showcase your unique style in writing",
    buttonText: "Download",
    imgSrc: ebook1,
    comingSoon: false,
  },
  {
    id: 2,
    title: "What makes a documentary film unique?",
    buttonText: "Download",
    imgSrc: ebook2,
    comingSoon: false,
  },
  {
    id: 3,
    title: "What makes a documentary film unique?",
    buttonText: "Download",
    imgSrc: ebook3,
    comingSoon: false,
  },
  {
    id: 4,
    title: "What makes a documentary film unique?",
    buttonText: "Download",
    imgSrc: ebook4,
    comingSoon: true,
  },
  {
    id: 5,
    title: "What makes a documentary film unique?",
    buttonText: "Download",
    imgSrc: ebook5,
    comingSoon: true,
  },
  {
    id: 6,
    title: "What makes a documentary film unique?",
    buttonText: "Download",
    imgSrc: ebook5,
    comingSoon: true,
  },
  {
    id: 7,
    title: "What makes a documentary film unique?",
    buttonText: "Download",
    imgSrc: ebook5,
    comingSoon: true,
  },
  {
    id: 8,
    title: "What makes a documentary film unique?",
    buttonText: "Download",
    imgSrc: ebook5,
    comingSoon: true,
  },
];

export const TermsData = [
  {
    title: "Terms and Conditions",
    description:
      "Maflam is an Online Platform for Learning Filmmaking in Arabic",
    textColor: "#CFCFCF",
    backgroundColor: "#0F1923",
    sections: [
      {
        title: "1. Definitions",
        items: [
          "Maflam refers to an online platform for filmmaking education managed by Eggdancer Production, registered in Saudi Arabia.",
          "User refers to anyone who accesses or uses Maflam's platform.",
          "Content includes, but is not limited to, videos, text, images, quizzes, and any other materials available on Maflam's platform.",
        ],
      },
      {
        title: "2. Access and Use",
        items: [
          "Maflam's platform is accessible and can be used by individuals who are at least 18 years old.",
          "Users agree to provide accurate and up-to-date information during registration.",
          "Users are responsible for keeping their account login details confidential.",
        ],
      },
      {
        title: "3. Content and Learning Materials",
        items: [
          "The content provided on Maflam's platform is intended for educational purposes only.",
          "Users may not reproduce, distribute, modify, or create derivative works from the content without explicit permission from the company managing Maflam's platform.",
        ],
      },
    ],
  },
];

// export const faqDataPage = [
//   {
//     faq: [

//       {question: "What is Maflam?",
//         answer: " "
//       },

//       {
//         question: "What is Maflam's platform?",
//         answer:
//           "Maflam is a SaaS online platform offering exclusive and comprehensive filmmaking content in Arabic.",
//       },
//       {
//         question: "When does my course subscription end?",
//         answer:
//           "At Maflam, we are committed to providing lifetime access to our filmmaking content...",
//       },
//       {
//         question: "How do you select instructors on Maflam’s platform?",
//         answer:
//           "We carefully select industry professionals with a track record in filmmaking, ensuring students learn from the best.",
//       },
//       {
//         question: "Is there practical content on the platform?",
//         answer:
//           "Yes, the platform integrates both theoretical and practical content. It includes exercises...",
//       },
//       {
//         question:
//           "Will I receive a completion certificate after finishing a course?",
//         answer: "Currently, all courses offer completion certificates...",
//       },
//     ],
//   }, 
// ];

export const faqDataPage = [
  {
    title: "About the Platform",
    faq: [
      {
        question: "What is Maflam?",
        answer: "Maflam is a SaaS online platform offering exclusive and comprehensive filmmaking content in Arabic."
      },
      {
        question: "When does my course subscription end?",
        answer: "At Maflam, we are committed to providing lifetime access to our filmmaking content..."
      },
    ]
  },
  {
    title: "About Our Courses",
    faq: [
      {
        question: "How do you select instructors on Maflam’s platform?",
        answer: "We carefully select industry professionals with a track record in filmmaking, ensuring students learn from the best."
      },
      {
        question: "Will I receive a completion certificate after finishing a course?",
        answer: "Currently, all courses offer completion certificates..."
      },
    ]
  }
];




export const learnData = [
  "In this course, you will learn how to become a director and manage a film set, as well as the key points to consider when choosing a script. You’ll also understand what to focus on during the preparation phase, how to select and work with actors, and how to interact with them effectively.",
  " You will dive deep into camera techniques, understanding the meaning behind camera movements, how to establish a scene, manage production, and make the most of each shooting day until the film reaches the editing room. Together, we will explore essential directing rules you must follow to professionally direct your first film.",
];

export const aboutInstructorData = {
  name: "Afnan Linjawi",
  details: [
    "A Screenwriter with a Master’s degree in Screenwriting from Falmouth University in the UK. Afnan has 10 years of experience in dramatic writing. She began her career writing plays before transitioning to screenwriting in 2017.",
    "  Afnan has received several awards for her screenwriting, including the ScreenCraft Award for Short Films, the Shockis American Award for Feature Film Treatments, and the Discop Award for Series Treatments.",
    " Three of her short films have been produced, with some earning festival awards. She has also contributed to several television series and feature films. Additionally, Afnan has facilitated screenwriting workshops at In5 Media in Dubai and has developed curriculum for screenwriting courses.",
  ],
};

export const FilmProductionInstructorData = {
  name: "Ayman khoja",
  details: [
    "A Screenwriter with a Master’s degree in Screenwriting from Falmouth University in the UK. Afnan has 10 years of experience in dramatic writing. She began her career writing plays before transitioning to screenwriting in 2017.",
    "  Afnan has received several awards for her screenwriting, including the ScreenCraft Award for Short Films, the Shockis American Award for Feature Film Treatments, and the Discop Award for Series Treatments.",
    " Three of her short films have been produced, with some earning festival awards. She has also contributed to several television series and feature films. Additionally, Afnan has facilitated screenwriting workshops at In5 Media in Dubai and has developed curriculum for screenwriting courses.",
  ],
};

export const FilmProductionlearnData = [
  "In this course, you will learn the fundamentals of production and the role of producers in filmmaking. You'll master financial aspects through effective planning and budgeting, as well as creating precise schedules. Additionally, you'll develop crucial skills for overseeing the film at every stage, working with distributors, and protecting the film's intellectual property rights. You’ll also cover other important details, and you'll have access to downloadable files and worksheets for practical exercises to enhance your skills.",
];